import { render, staticRenderFns } from "./Flexpropcard.vue?vue&type=template&id=4711b58d&"
import script from "./Flexpropcard.vue?vue&type=script&lang=js&"
export * from "./Flexpropcard.vue?vue&type=script&lang=js&"
import style0 from "./Flexpropcard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports